import React from "react"
import Header from "./header"
import Image from "./image"
import GrayLine from "./gray-line"
import Subtitle from "./subtitle"

const Album = ({ attributes, images, title, artists_name, editing }) => {
  return (
    <table
      data-testid="album"
      {...attributes}
      style={{ borderCollapse: "collapse", padding: "0" }}
    >
      <tbody>
        <tr>
          <Image images={images} editing={editing} />
          <td
            style={{
              backgroundColor: "black",
              background: "linear-gradient(gray, 30%, black)",
              width: "250px",
              paddingLeft: "12px",
              paddingRight: "12px"
            }}
          >
            <Header title={title} />
            <Subtitle subtitle={artists_name} />
            <GrayLine />
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Album
